module.exports = __webpack_public_path__ + "img/sort-asc-blue.39dd15b4.svg";